import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import FormC2bUserData from '@adv-mt/mt-form-c2b-user-data'
import Layout from '@adv-mt/mt-layout-basic'

import {useLandingInstantOfferTracking} from '../../../useLandingInstantOfferTracking.js'
import HeaderStep from '../../HeaderStep/index.js'

const BASE_CLASS_NAME = 'mt-Landing-InstantOffer-StepUserDataForm'

const LandingInstantOfferStepUserDataForm = ({onClickSubmit, origin}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const APP_KEY_LITERAL = config.get('APP_NAME')

  const {pageTrackUserFormStep, trackFieldAutocompletion, trackFieldChange, trackSubmitUserFormError} =
    useLandingInstantOfferTracking()

  useMount(() => {
    pageTrackUserFormStep({origin})
  })

  const handleFormSubmitError = ({errors}) => {
    const {formErrorTypes} = domain.get('config').get('form')
    trackSubmitUserFormError({errorType: formErrorTypes.fieldError, errors})
  }

  return (
    <Layout.Container isFullWidth>
      <main className={BASE_CLASS_NAME}>
        <HeaderStep
          pretitle={i18n.t(`INSTANT_OFFER.STANDALONE.VEHICLE_FORM.PRETITLE.${APP_KEY_LITERAL}`)}
          title={i18n.t('INSTANT_OFFER.STANDALONE.USER_DATA.TITLE')}
          description={i18n.t('INSTANT_OFFER.STANDALONE.USER_DATA.DESCRIPTION')}
        />
        <FormC2bUserData
          onAutocompleteFields={trackFieldAutocompletion}
          onClickSubmit={onClickSubmit}
          onFieldChange={trackFieldChange}
          onSubmitError={handleFormSubmitError}
        />
      </main>
    </Layout.Container>
  )
}

LandingInstantOfferStepUserDataForm.displayName = 'LandingInstantOfferStepUserDataForm'

LandingInstantOfferStepUserDataForm.propTypes = {
  onClickSubmit: PropTypes.func.isRequired,
  origin: PropTypes.string
}

export default LandingInstantOfferStepUserDataForm
